import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Link,
  Stack,
  Divider,
} from "@mui/material";
import GmeTeachingHospitalDetailContent from "./GmeTeachingHospitalDetailContent";

/**
 * Default marker detail: popup lines, generic meta key/values, website / EMRA links.
 */
function GenericLayerMarkerDetailContent({ marker, layerMeta }) {
  const lines = Array.isArray(marker.popupLines) ? marker.popupLines : [];
  const meta = marker.meta && typeof marker.meta === "object" ? marker.meta : {};
  const website = marker.website || "";
  const emra = meta.emraMatchUrl || "";

  const metaEntries = Object.entries(meta).filter(
    ([k]) => k !== "emraMatchUrl" && String(meta[k]).trim() !== ""
  );

  return (
    <Stack spacing={1}>
      {lines.map((line, i) => (
        <Typography key={i} variant="body2">
          {line}
        </Typography>
      ))}
      {metaEntries.length > 0 && (
        <>
          <Divider sx={{ my: 1 }} />
          {metaEntries.map(([k, v]) => (
            <Typography key={k} variant="body2" color="text.secondary">
              <strong>
                {k.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase())}:
              </strong>{" "}
              {String(v)}
            </Typography>
          ))}
        </>
      )}
      {(website || emra) && <Divider sx={{ my: 1 }} />}
      {website ? (
        <Link href={website} target="_blank" rel="noopener noreferrer">
          Program website
        </Link>
      ) : null}
      {emra ? (
        <Link href={emra} target="_blank" rel="noopener noreferrer">
          View on EMRA Match
        </Link>
      ) : null}
      {layerMeta?.sourceUrl ? (
        <Typography variant="caption" color="text.secondary">
          Layer: {layerMeta.categoryLabel || layerMeta.categoryId}
        </Typography>
      ) : null}
    </Stack>
  );
}

/**
 * Marker detail dialog for static overlay layers. Content can differ by `categoryId`
 * (dropdown selection), e.g. GME teaching hospitals vs EM residencies.
 */
const LayerMarkerDetailModal = ({ open, marker, layerMeta, categoryId, onClose }) => {
  if (!marker) return null;

  const cid = categoryId || layerMeta?.categoryId || "";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{marker.name || "Location"}</DialogTitle>
      <DialogContent>
        {cid === "gme_teaching_hospitals" ? (
          <GmeTeachingHospitalDetailContent marker={marker} layerMeta={layerMeta} />
        ) : (
          <GenericLayerMarkerDetailContent marker={marker} layerMeta={layerMeta} />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LayerMarkerDetailModal;
